import React from 'react'

import { MEDIA_URL } from '../config/general';

const Brick = ({ id, construction, content, brickClick, charSprite, goalSprite, winSprite, objSprite, laberintoSprite }) => {

    const spritePosition = {
      '1,0,0,1': '0 0',
      '1,0,0,0': '33% 0',
      '1,1,0,0': '66% 0',
      '0,1,0,1': '100% 0',
      '0,0,0,1': '0 33%',
      '0,0,0,0': '33% 33%',
      '0,1,0,0': '66% 33%',
      '1,0,1,0': '100% 33.6%',
      '0,0,1,1': '0 66%',
      '0,0,1,0': '33% 66%',
      '0,1,1,0': '66% 66%',
      '1,1,1,1': '100% 66%',
      '1,1,0,1': '0 100%',
      '1,0,1,1': '33% 100%',
      '1,1,1,0': '66% 100%',
      '0,1,1,1': '100% 100%',
    }

    const bickStyle = {
        backgroundImage: `url(${ MEDIA_URL + laberintoSprite })`,
        backgroundSize: '404%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: spritePosition[construction.toString()],
        // borderTopStyle: construction[0] ? line : 'none',
        // borderRightStyle: construction[1] ? line : 'none',
        // borderBottomStyle: construction[2] ? line : 'none',
        // borderLeftStyle: construction[3] ? line : 'none',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }

    const brickChar = {
      backgroundImage: `url(${ MEDIA_URL + charSprite })`,
      transform: 'scale(1.8)'
    }

    const brickGoal = {
      backgroundImage: `url(${ MEDIA_URL + goalSprite })`,
      transform: 'scale(1.8)'
    }

    const brickWin = {
      backgroundImage: `url(${ MEDIA_URL + winSprite })`,
      transform: 'scale(1.8)'
    }

    const brickObj1 = {
      backgroundImage: `url(${ MEDIA_URL + objSprite })`,
      backgroundSize: '300%',
      backgroundPosition: '0 0',
      transform: 'scale(1.33)'
    }

    const brickObj2 = {
      backgroundImage: `url(${ MEDIA_URL + objSprite })`,
      backgroundSize: '300%',
      backgroundPosition: '50% 0',
      transform: 'scale(1.33)'
    }
    const brickObj3 = {
      backgroundImage: `url(${ MEDIA_URL + objSprite })`,
      backgroundSize: '300%',
      backgroundPosition: '100% 0',
      transform: 'scale(1.33)'
    }

    const brickObj4 = {
      backgroundImage: `url(${ MEDIA_URL + objSprite })`,
      backgroundSize: '300%',
      backgroundPosition: '0 100%',
      transform: 'scale(1.33)'
    }

    const brickObj5 = {
      backgroundImage: `url(${ MEDIA_URL + objSprite })`,
      backgroundSize: '300%',
      backgroundPosition: '50% 100%',
      transform: 'scale(1.33)'
    }

    const brickObj6 = {
      backgroundImage: `url(${ MEDIA_URL + objSprite })`,
      backgroundSize: '300%',
      backgroundPosition: '100% 100%',
      transform: 'scale(1.33)'
    }

    const drawContent = () => {
      if( content === 1 ){
        return <span style={ brickChar } ></span>
      }
      else if (content === 2){
        return <span style={ brickGoal }></span>
      }
      else if (content === 3){
        return <span style={ brickWin }></span>
      }
      else if (content === 4){
        return <span style={ brickObj1 }></span>
      }
      else if (content === 5){
        return <span style={ brickObj2 }></span>
      }
      else if (content === 6){
        return <span style={ brickObj3 }></span>
      }
      else if (content === 7){
        return <span style={ brickObj4 }></span>
      }
      else if (content === 8){
        return <span style={ brickObj5 }></span>
      }
      else if (content === 9){
        return <span style={ brickObj6 }></span>
      }
      else{
        return ''
      }
    }
  return (
    <div className='brick' style={ bickStyle } onClick={ () => brickClick( id ) }>
      { drawContent() }
    </div>
  )
}

export default Brick